module.exports = __webpack_public_path__ + "src/assets/fonts/glyphicons-halflings-regular.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/glyphicons-halflings-regular.ttf
// module id = 34
// module chunks = 0